// Configuration for Zendesk Widget display
// Add routes where the Zendesk widget should be displayed
export const ZENDESK_ALLOWED_ROUTES = [
    "/dashboard",
    "/dashboard/market-data",
    "/buy-sell",
    "/digital-assets",
    "/digital-assets/:id",
    "/trade",
    "/eotc",
    "/wallets",
    "/settings/:section"
  ];